export default __webpack_public_path__ + "SourceSansPro-Regular.ttf";